// CSV cell helpers, kept free of app imports so tests and pure utilities can use them.
export function excelSafeExport(value: string): string {
  if (value === null || value === undefined) return '';

  const str = String(value);

  // Force text for numeric-looking IDs
  if (/^\d{10,}$/.test(str)) {
    return `="${str}"`;
  }

  return str;
}

export function csvEscape(field: string): string {
  if (field.includes(',') || field.includes('"') || field.includes('\n')) {
    return '"' + field.replace(/"/g, '""') + '"';
  }
  return field;
}
